// Was das Medien-Modul zum Baum beiträgt (lib/shell/tree.svelte.ts hängt es
// ein): die Zahlen rechts an den Seiten. Die Seiten selbst kommen aus
// routen.ts; Filme und Serien nesten im Baum unter „Medien“ (Pfad-Präfix),
// ein Symbol bekommen sie wie jede Zuhause-Seite von ihrem Bereich.

import { getMedien } from "./medien.svelte";

const zahl = (n: number | undefined): string => (n ? n.toLocaleString("de-DE") : "");

/** Text rechts an einer Seite des Moduls („580“). Leer, solange der Store
 *  leer ist -- der Store startet erst mit der ersten Medien-Seite. */
export const MEDIEN_ZAHLEN: Record<string, () => string> = {
  "/zuhause/medien": () => zahl(getMedien()?.titel.length),
  "/zuhause/medien/filme": () => zahl(getMedien()?.titel.filter((t) => t.art === "film").length),
  "/zuhause/medien/serien": () => zahl(getMedien()?.titel.filter((t) => t.art === "serie").length),
};
